import React from 'react'

const InstChat = () => {
  return (
    <div>InstChat</div>
  )
}

export default InstChat